import { atsApiQuery } from '..';

export const compensationSettingsApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getCompensationSettings: builder.query({
        providesTags: ['GetCompensationSettings'],
        transformResponse: (response) => response?.data,
        query: () => {
          return {
            method: 'get',
            url: `/compensations/settings`,
          };
        },
        staleTime: 0,
      }),

      getCompensationCurrencies: builder.query({
        providesTags: ['GetCompensationCurrencies'],
        transformResponse: (response) => response?.data,
        query: () => {
          return {
            method: 'get',
            url: `/compensations/currencies`,
          };
        },
        staleTime: 0,
      }),

      updateCompensationSettings: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload }) => {
          return {
            method: 'put',
            url: `/compensations/settings`,
            data: { ...payload },
          };
        },
        invalidatesTags: (result) => {
          if (result) {
            return [{ type: 'GetCompensationSettings' }];
          }
          return [];
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetCompensationSettingsQuery,
  useGetCompensationCurrenciesQuery,
  useUpdateCompensationSettingsMutation,
} = compensationSettingsApi;
